import * as React from "react";
import Table from "@cloudscape-design/components/table";
import Box from "@cloudscape-design/components/box";
import SpaceBetween from "@cloudscape-design/components/space-between";
import Button from "@cloudscape-design/components/button";
import Header from "@cloudscape-design/components/header";
import { Link } from "@cloudscape-design/components";

export const AuditTable = () => {
  return (
    <Table
      renderAriaLive={({
        firstIndex,
        lastIndex,
        totalItemsCount
      }) =>
        `Displaying items ${firstIndex} to ${lastIndex} of ${totalItemsCount}`
      }
      columnDefinitions={[
        {
          id: "country",
          header: "Country",
          cell: item => (
            <Link href="#">{item.name || "-"}</Link>
          ),
          sortingField: "name",
          isRowHeader: true
        },
        {
          id: "previous",
          header: "Previous number",
          cell: item => item.previous || "-",
          sortingField: "alt"
        },
        {
          id: "current",
          header: "Current number",
          cell: item => item.current || "-"
        },
        {
          id: "time",
          header: "Time of change",
          cell: item => item.time || "-"
        }
      ]}
      enableKeyboardNavigation
      items={[]}
      loadingText="Loading resources"
      sortingDisabled
      empty={
        <Box
          margin={{ vertical: "xs" }}
          textAlign="center"
          color="inherit"
        >
          <SpaceBetween size="m">
            <b>No changes recorded</b>
          </SpaceBetween>
        </Box>
      }
      header={<Header> Table of changes </Header>}
    />
  );
}